import React from "react";
import { string, bool, func, node, oneOfType } from "prop-types";
import * as style from "./styles.module.scss";

const RadioCard = ({ children, isChecked, onChange }) => (
  <label
    className={`${style.radioButton__label} ${style.radioCard} ${
      isChecked ? style.radioCard__checked : ""
    }`}
  >
    <input
      type="radio"
      className={`${style.radioButton}`}
      onChange={onChange}
      checked={isChecked}
      autoComplete="off"
    />
    <span className={style.radioButton__checkmark}></span>
    {children}
  </label>
);

RadioCard.propTypes = {
  children: oneOfType([node, string]),
  isChecked: bool,
  onChange: func,
};

export default RadioCard;
